import * as axios from '~/utilities/axios'
import * as FileTools from '~/utilities/files'
import * as StringTools from '~/utilities/string'

import { USE_PARSE_PROXY } from '~/utilities/constants'

const b64ToBlob = (base64String, contentType) =>
  new Promise(resolve => {
    const cleanBase64String = FileTools.stripBase64Start(base64String)

    const SLICE_SIZE = 512
    const byteCharacters = atob(cleanBase64String)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += SLICE_SIZE) {
      const slice = byteCharacters.slice(offset, offset + SLICE_SIZE)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    resolve(blob)
  })

export const upload = (fileName, contentType, imageData, sessionToken) => {
  const additionalHeaders = {
    'Content-Type': contentType
  }
  return b64ToBlob(imageData, contentType).then(bufferEncoded => {
    return axios
      .secure(sessionToken, undefined, additionalHeaders)
      .post(`${process.env.PARSE_DIR}/files/${fileName}`, bufferEncoded)
      .then(res => res.data)
      .catch(axios.parseError)
  })
}

export const downloadBase64 = (fileUrl, sessionToken) => {
  const options = {
    responseType: 'blob'
  }

  let targetUrl = fileUrl

  // If we are using the parse proxy lets load images through the proxy
  if (USE_PARSE_PROXY) {
    targetUrl = StringTools.removeSubstring(
      fileUrl,
      `${process.env.PARSE_SERV_URL}/parse`
    )
    targetUrl = `${process.env.PARSE_DIR}${targetUrl}`
  }
  return axios
    .secure(sessionToken)
    .get(targetUrl, options)
    .then(res => res.data)
    .then(FileTools.encodeImageFileAsURL)
    .catch(axios.parseError)
}
